import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

// Styled component for the IconButton
const StyledIconButton = styled(IconButton)({
  color: '#d3d3d3',
  '&:hover': {
    color: '#a9a9a9',
  },
});

// Enhanced Tooltip with extended visibility
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    enterDelay={300}
    enterTouchDelay={500}
    leaveDelay={30000}
    disableInteractive={false}
    {...props}
    classes={{ popper: className }}
  />
))({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#000',
    color: '#fff',
    fontSize: '0.875rem',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
    borderRadius: '4px',
    padding: '10px',
    maxWidth: '280px',
    lineHeight: 1.5,
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#000',
  },
});

const GenericTooltip = ({
  title,
  iconButtonClassName = 'custom-icon-button',
  iconClassName = 'custom-icon',
  iconStyle,
  iconSize = 'small',
}) => {
  const [open, setOpen] = useState(false);

  const handleTooltipOpen = () => setOpen(true);
  const handleTooltipClose = () => setOpen(false);

  return (
    <CustomTooltip
      title={title}
      placement="top"
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      arrow
    >
      <StyledIconButton
        aria-label="tooltip"
        onClick={handleTooltipOpen}
        onMouseEnter={handleTooltipOpen}
        onMouseLeave={handleTooltipClose}
        className={iconButtonClassName}
        style={{ marginLeft: '2px', ...iconStyle }}
      >
        <HelpOutlineIcon
          className={iconClassName}
          style={{
            fontSize:
              iconSize === 'small' ? '16px' : iconSize === 'large' ? '24px' : '20px',
          }}
        />
      </StyledIconButton>
    </CustomTooltip>
  );
};

GenericTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  iconButtonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  iconStyle: PropTypes.object,
  iconSize: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default GenericTooltip;
